export default __webpack_public_path__ + "static/media/modern-design-system-light-large.1139ced1.jpg";